import Loadable from '../../components/loadable';

const ContactFlagsReport = Loadable({
  loader: () => import('../../pages/reports/contact_flags_report/index'),
});

angular.module('gym').value('ContactFlagsReport', ContactFlagsReport);

const ContactFlagsReportFiltersModal = Loadable({
  loader: () =>
    import('../../pages/reports/contact_flags_report/contact_flags_report_filters_modal'),
  type: 'modal',
});

angular.module('gym').value('ContactFlagsReportFiltersModal', ContactFlagsReportFiltersModal);
